// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__IbS7C","card--disabled":"styles_card--disabled__m3e0c","skeleton-animation":"styles_skeleton-animation__OsfKF"};